module.exports = __webpack_public_path__ + "img/putter5.4d783e46.jpg";